import { customSpecComponent } from '@/components/tasklist/forms/customComponents'
import validationConstraintsSpec from '@/utils/constants/tasklist/validationContraints'
import {
  GeneratedFormSpecTypes,
  GeneratedFormTypes,
  GeneratedValidationConstraintsTypes,
} from '@/utils/types/generatedForm'
import { TaskDataTasklistTypes } from '@/utils/types/tasklist'
import moment from 'moment'

export const generateCustomSpec = (camundaForm: GeneratedFormTypes[], taskData?: TaskDataTasklistTypes) => {
  let SpecData = camundaForm.map((form: GeneratedFormTypes) => {
    let template: GeneratedFormSpecTypes = {
      form_field_type: form.type_name,
      defaultValue: taskData?.variables?.[form.id] ?? null,
      label: form.label,
      name: form.id,
      type: 'text',
      properties: form.properties,
    }

    // create validation constraints
    form.validation_constraints?.forEach((constraint: GeneratedValidationConstraintsTypes) => {
      template = {
        ...template,
        constraints: {
          ...template.constraints,
          [validationConstraintsSpec[constraint.name]]: constraint.configuration ?? true,
        },
      }
    })

    if (form.type_name === 'INPUT_SELECT' || form.type_name === 'INPUT_RADIO' || form.type_name === 'INPUT_CHECKBOX') {
      return {
        ...template,
        select_options: {
          option_key: 'key',
          option_label: 'label',
          options: Object.keys(form.properties).map(key => {
            return {
              label: form.properties[key],
              key: key,
            }
          }),
        },
      }
    }

    if (form.type_name === 'INPUT_DATE') {
      return {
        ...template,
        defaultValue: moment(taskData?.variables?.[form.id] as string | Date | null, 'DD-MM-YYYY').isValid()
          ? moment(taskData?.variables?.[form.id] as string | Date | null, 'DD-MM-YYYY').format('YYYY-MM-DD')
          : null,
      }
    }

    if (form.type_name === 'INPUT_DATETIME-LOCAL') {
      return {
        ...template,
        defaultValue: moment(taskData?.variables?.[form.id] as string | Date | null, 'DD-MM-YYYY HH:mm').isValid()
          ? moment(taskData?.variables?.[form.id] as string | Date | null, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm')
          : null,
      }
    }
    return template
  })

  SpecData = SpecData.map((spec: GeneratedFormSpecTypes) => {
    if (spec.properties?.NAME === 'INPUT_MULTI_FILE_UPLOAD' && spec.form_field_type === 'CUSTOM_COMPONENT') {
      return {
        ...spec,
        form_field_type: 'INPUT_MULTI_FILE_UPLOAD',
        type: 'file',
      }
    }

    return spec
  })

  SpecData.forEach((spec: GeneratedFormSpecTypes) => {
    if (spec.form_field_type === 'CUSTOM_COMPONENT') {
      if (spec.properties?.NAME in customSpecComponent) {
        SpecData = [...SpecData, ...customSpecComponent[spec.properties?.NAME]]
      }
    }
  })

  return SpecData
}
